import React from "react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { FaShippingFast, FaCreditCard, FaCheckCircle } from "react-icons/fa";

const CheckoutSteps = ({ step2, step3 }) => {
  return (
    <Nav className="justify-content-center mb-4">
      <Nav.Item>
        {step2 ? (
          <LinkContainer to="/shipping">
            <Nav.Link className="step active">
              <FaShippingFast className="step-icon" /> Shipping & Payment
            </Nav.Link>
          </LinkContainer>
        ) : (
          <Nav.Link disabled className="step">
            <FaShippingFast className="step-icon" /> Shipping & Payment
          </Nav.Link>
        )}
      </Nav.Item>

      <Nav.Item className="step-divider">——</Nav.Item>

      <Nav.Item>
        {step3 ? (
          <LinkContainer to="/place-order">
            <Nav.Link className="step active">
              <FaCheckCircle className="step-icon" /> Place Order
            </Nav.Link>
          </LinkContainer>
        ) : (
          <Nav.Link disabled className="step">
            <FaCheckCircle className="step-icon" /> Place Order
          </Nav.Link>
        )}
      </Nav.Item>

      <style>
        {`
          .step {
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 16px;
            color: #6c757d;
          }
          .step.active {
            color: #007bff;
          }
          .step-icon {
            font-size: 18px;
          }
          .step-divider {
            padding: 0 10px;
            font-size: 18px;
            color: #6c757d;
            display: flex;
justify-content: center;
align-items: center;
          }
        `}
      </style>
    </Nav>
  );
};

export default CheckoutSteps;

// import React from "react";
// import { Nav } from "react-bootstrap";
// import { LinkContainer } from "react-router-bootstrap";

// const CheckoutSteps = ({ step1, step2, step3 }) => {
//   return (
//     <Nav className="justify-content-center mb-4">
//       {/* <Nav.Item>
//         {step1 ? (
//           <LinkContainer to="/login">
//             <Nav.Link>Sign In</Nav.Link>
//           </LinkContainer>
//         ) : (
//           <Nav.Link disabled>Sign In</Nav.Link>
//         )}
//       </Nav.Item> */}
//       <Nav.Item>
//         {step2 ? (
//           <LinkContainer to="/shipping">
//             <Nav.Link>Shipping & Payment Method</Nav.Link>
//           </LinkContainer>
//         ) : (
//           <Nav.Link disabled>Shipping & Payment Method</Nav.Link>
//         )}
//       </Nav.Item>
//       <Nav.Item></Nav.Item>
//       <Nav.Item>
//         {step3 ? (
//           <LinkContainer to="/place-order">
//             <Nav.Link>Place order</Nav.Link>
//           </LinkContainer>
//         ) : (
//           <Nav.Link disabled>Place order</Nav.Link>
//         )}
//       </Nav.Item>
//     </Nav>
//   );
// };

// export default CheckoutSteps;
